var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78911 29.0765C8.38338 29.0758 7.98482 28.9694 7.63266 28.7679C6.83966 28.3186 6.34668 27.4463 6.34668 26.4993V7.33517C6.34668 6.38556 6.83966 5.5159 7.63266 5.06654C7.99321 4.85932 8.4028 4.75277 8.81862 4.758C9.23445 4.76323 9.64123 4.88006 9.99645 5.09628L26.3752 14.9004C26.7165 15.1144 26.9979 15.4116 27.193 15.7642C27.388 16.1167 27.4903 16.513 27.4903 16.9159C27.4903 17.3188 27.388 17.7151 27.193 18.0677C26.9979 18.4202 26.7165 18.7174 26.3752 18.9314L9.99381 28.7382C9.63028 28.958 9.21391 29.0749 8.78911 29.0765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.48a98ef01f7227c294209ec282ba443e.svg";
export { ForwardRef as ReactComponent };